export default "__VITE_ASSET__BXmNBsBA__";